import {OfferType} from "../../types/OfferType";

export const getPropertyTypeMessage = (offerType: OfferType[]) => {
    if (offerType[0] === OfferType.COMMERCIAL) {
        return "Lokale użytkowe";
    }

    if (offerType[0] === OfferType.FLAT) {
        return "Mieszkania";
    }

    if (offerType[0] === OfferType.HOUSE) {
        return "Domy";
    }

    return "Mieszkania i domy";
};
import {OfferType} from "../../types/OfferType";

export const getPropertyTypeMessage = (offerType: OfferType[]) => {
    if (offerType[0] === OfferType.COMMERCIAL) {
        return "Lokale użytkowe";
    }

    if (offerType[0] === OfferType.FLAT) {
        return "Mieszkania";
    }

    if (offerType[0] === OfferType.HOUSE) {
        return "Domy";
    }

    return "Mieszkania i domy";
};
